var exports = {
  "D": "RelationshipsListAllModal_TitleCounter__m5P5R2",
  "G": "RelationshipsListAllModal_HovercardWrapper__4oTK7r",
};

module.exports = exports;
